import { render, staticRenderFns } from "./msgRecord.vue?vue&type=template&id=66e69b55&scoped=true&"
import script from "./msgRecord.vue?vue&type=script&lang=js&"
export * from "./msgRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e69b55",
  null
  
)

export default component.exports